<template>
  <div>
    
    <!-- <el-row :gutter="10">
      <el-col :xs="24" :sm="8" :md="8">
        <c-panel>

          <div class="l-level">
            <div class="l-level__left">
              <i class="fa fa-chart-bar"></i>
            </div>
            <div class="l-level__right">
              <div class="u-text-right">
                <div>TOTAL DE INSTITUIÇÕES</div>
                <div class="val">-</div>
              </div>
            </div>
          </div>        

        </c-panel>         
      </el-col>

      <el-col :xs="24" :sm="8" :md="8">
        <c-panel>

          <div class="l-level">
            <div class="l-level__left">
              <i class="fa fa-chart-bar"></i>
            </div>
            <div class="l-level__right">
              <div class="u-text-right">
                <div>TOTAL DE ALUNOS</div>
                <div class="val">-</div>
              </div>
            </div>
          </div>        

        </c-panel>         
      </el-col>

      <el-col :xs="24" :sm="8" :md="8">
        <c-panel>

          <div class="l-level">
            <div class="l-level__left">
              <i class="fa fa-chart-line"></i>
            </div>
            <div class="l-level__right">
              <div class="u-text-right">
                <div>TOTAL DE MATRÍCULAS</div>
                <div class="val">-</div>
              </div>
            </div>
          </div>        

        </c-panel>         
      </el-col>  
    </el-row> -->

    <c-panel>

      <div class="container-table">
          <table v-loading="!statusList" class="table table-striped">
              <thead>
                  <tr>
                      <th>Instituição</th>
                      <th class="u-text-center">Curso</th>
                      <th class="u-text-center">Vagas Iniciais</th>
                      <th class="u-text-center">Matriculados</th>
                  </tr>
              </thead>
              <tbody>
                  <tr v-for="(item, i) in items" :key="i">
                      <td>{{ item.instituicao }}</td>
                      <td class="u-text-center">{{ item.curso }}</td>
                      <td class="u-text-center">{{ item.qtd_vagas }}</td>
                      <td class="u-text-center">{{ item.matriculados }}</td>                      
                  </tr>
              </tbody>
              <tfoot>
                  <tr v-if="statusList && items.length == 0" style="border-top: 1px solid #ddd;">
                      <td colspan="100%" class="u-text-center">
                          <span>- nenhum registro -</span>
                      </td>
                  </tr>
              </tfoot>
          </table>
      </div>

    </c-panel>
  
  </div>
</template>
<script>

export default {
  data () {
    return {
      statusList: false,
      items: []
    }
  },
  mounted() {
        
      this.loadingInstituicoes();
  },
  methods: {    
    loadingInstituicoes(){

      this.statusList = false;
      this.items = [];

      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getInstituicaoWithPreMatriculasForHome`, this.$store.getters.getHeaderAuth).then(response => {

        this.items = response.data;
        this.statusList = true;

      }).catch((error) => { this.$store.commit('throwException', error); });

    },
  },

  
}
</script>
